export default {
  title: 'Автоматизации',
  description: 'Запускайте агентов по расписанию.',
  createAutomation: 'Создать автоматизацию',
  editAutomation: 'Редактировать автоматизацию',
  scheduleFormDescription: 'Укажите, когда агент должен запускаться.',
  laplaceDefault: 'Laplace',
  agent: 'Агент',
  workspace: 'Воркспейс',
  name: 'Название',
  namePlaceholder: 'Например, Еженедельный отчёт',
  schedule: 'Расписание',
  scheduleInput: 'Когда запускать',
  schedulePlaceholder: 'Каждый понедельник в 9:00',
  interpretingSchedule: 'Проверяем расписание...',
  scheduleUnderstood: 'Расписание распознано',
  scheduleInvalid: 'Не удалось распознать расписание.',
  schedulePreviewFailed: 'Не удалось проверить расписание.',
  nextRunsPreview: 'Следующие запуски: {{dates}}',
  timezone: 'Часовой пояс',
  prompt: 'Задача при каждом запуске',
  promptDescription:
    'Укажите, какую работу выполнять по этому расписанию. Не повторяйте постоянные инструкции агента — добавьте область работы, входные данные и ожидаемый результат.',
  promptPlaceholder:
    'Например: проверь новые письма за прошедшую неделю, выдели важные и подготовь краткую сводку.',
  cancel: 'Отмена',
  save: 'Сохранить',
  saving: 'Сохранение...',
  search: 'Поиск автоматизаций',
  allWorkspaces: 'Все воркспейсы',
  allStatuses: 'Все статусы',
  active: 'Активна',
  paused: 'Выключена',
  provisioning: 'Настраивается',
  error: 'Ошибка',
  automation: 'Автоматизация',
  status: 'Статус',
  nextRun: 'Следующий запуск',
  lastRun: 'Последний запуск',
  never: 'Нет',
  disable: 'Выключить',
  enable: 'Включить',
  edit: 'Редактировать',
  delete: 'Удалить',
  empty: 'Автоматизаций пока нет.',
  noResults: 'По вашему запросу ничего не найдено.',
  loadFailed: 'Не удалось загрузить автоматизации.',
  retry: 'Повторить',
  openChat: 'Открыть чат',
  deleteTitle: 'Удалить автоматизацию?',
  deleteDescription:
    'Автоматизация «{{name}}» будет удалена вместе с настройками.',
  automationCreated: 'Автоматизация создана',
  automationUpdated: 'Автоматизация обновлена',
  automationDeleted: 'Автоматизация удалена',
  actionFailed: 'Не удалось выполнить действие',
  saveFailed: 'Не удалось сохранить автоматизацию',
}
